import Big from '../../../math/math';

/**
 * Round a value to the nearest step interval using Big.js for precision.
 *
 * - step === 0 → no rounding, return value rounded to 2 decimal places
 * - step > 0   → snap to nearest multiple of step (uses Big.roundHalfUp)
 *
 * Returns a Big instance to avoid unnecessary Big→number→Big conversions
 * when the result is stored back in the grid store.
 */
export const roundToStep = (value: number, step: number): Big => {
    const bigValue = new Big(value.toString());

    if (step === 0) {
        return bigValue.round(2);
    }

    const bigStep = new Big(step.toString());
    return bigValue.div(bigStep).round(0).times(bigStep).round(2);
};
